import {Button, Card, Flex, Form, Input, notification, Row, Typography} from 'antd';
import { useEffect, useState } from 'react';
import './style.scss';
import {useNavigate, useLocation} from 'react-router-dom';
import { Utils } from '../../utils';
import {RouteNames} from "../../router/routeNames";
import {useDispatch} from "react-redux";
import {resetNewPassword} from "../../store/users";

const ResetPassword = () => {
  const [form] = Form.useForm();
  const router = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [apiNotification, contextHolder] = notification.useNotification();
  const [loading, setLoading] = useState(false);

  // Проверяем токен при загрузке страницы
  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const token = query.get('token');

    if (!token) {
      Utils.ErrorOpenNotification(
        'topRight',
        5,
        'Неверная ссылка для сброса пароля',
        '',
        apiNotification,
      );
      router(RouteNames.LOGIN);
      return;
    }
  }, [location.search]);

  const onFinish = async (values: {
    password: string;
    confirmPassword: string;
  }) => {
    if (values.password !== values.confirmPassword) {
      form.setFields([
        {
          name: 'confirmPassword',
          errors: ['Пароли не совпадают'],
        },
      ]);
      return;
    }

    try {
      setLoading(true);
      const query = new URLSearchParams(location.search);
      const token = query.get('token');
      if (!token) {
        return;
      }

      dispatch(resetNewPassword({ pass: values.password, token: token }));
      setTimeout(() => router(RouteNames.LOGIN), 500);
    } catch (error: unknown) {
      Utils.ErrorOpenNotification(
        'topRight',
        5,
        'Ошибка при изменении пароля',
        '',
        apiNotification,
      );
    } finally {
      setLoading(false);
    }
  };
  const clickRegistration = () => {
    router(RouteNames.REGISTRATION);
  };
  return (
    <>
      {contextHolder}
      <Flex
        align="center"
        gap={10}
        style={{ position: 'absolute', right: 20, top: 30 }}
      >
        <Typography.Paragraph
          style={{
            fontWeight: 600,
            margin: 0,
          }}
        >
          Нет аккаунта?
        </Typography.Paragraph>
        <Button
          onClick={clickRegistration}
          type="primary"
          style={{ width: 200 }}
        >
          Зарегистрироваться
        </Button>
      </Flex>
      <Row
        justify="space-around"
        align="middle"
        className="h100"
      >
        <Flex
          vertical
          align="center"
          gap={30}
          className="container-login"
        >
          <Card
            style={{
              borderRadius: 12,
              width: 600,
              paddingTop: '4%',
              paddingLeft: 100,
              paddingRight: 100,
              boxShadow: '5px 8px 24px 5px rgba(208, 216, 243, 0.6)',
            }}
          >
            <Flex
              align={'center'}
              justify={'center'}
              vertical
            >
              <h1>Изменение пароля</h1>
              <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                autoComplete="off"
                style={{ width: '100%' }}
              >
                <Form.Item
                  label="Новый пароль"
                  name="password"
                  className={'smallStep'}
                  rules={[
                    { required: true, message: 'Введите новый пароль' },
                    {
                      min: 8,
                      message: 'Пароль должен быть не менее 8 символов',
                    },
                  ]}
                >
                  <Input.Password placeholder="Новый пароль" />
                </Form.Item>

                <Form.Item
                  className={'bigStep'}
                  label="Подтвердите пароль"
                  name="confirmPassword"
                  dependencies={['password']}
                  rules={[
                    { required: true, message: 'Подтвердите пароль' },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue('password') === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error('Пароли не совпадают'));
                      },
                    }),
                  ]}
                >
                  <Input.Password placeholder="Подтвердите пароль" />
                </Form.Item>
                <Flex
                  align={'center'}
                  vertical
                  gap={20}
                >
                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      loading={loading}
                      style={{ width: '100%', marginTop: '20px' }}
                      block
                    >
                      Сохранить новый пароль
                    </Button>
                  </Form.Item>
                </Flex>
              </Form>
            </Flex>
          </Card>
          <Flex gap={10}>
            <Typography.Paragraph
              style={{
                fontWeight: 600,
                margin: 0,
              }}
            >
              Нет аккаунта?
            </Typography.Paragraph>
            <Typography.Link
              onClick={clickRegistration}
              style={{
                color: 'black',
                textDecoration: 'underline',
                cursor: 'pointer',
              }}
            >
              Зарегистрироваться
            </Typography.Link>
          </Flex>
        </Flex>
      </Row>
    </>
  );
};

export default ResetPassword;
